import React, { useEffect, useRef } from 'react';

// 정산 항목 입력 드로어 — 수기 추가 / 항목 수정 공용 (Jin 지시 2026-08-31).
// 구 모달은 12칸이 세로 한 줄로 나열돼 스크롤 없이 읽히지 않았다. 우측 슬라이드 드로어 + 4섹션 그리드로 재구성.
//
// **표현 컴포넌트다** — 상태/API/저장 payload 는 전부 CancelAgencySettlement.js 에 남아 있다.
// 여기 있는 로직은 폼 입력에 붙는 것뿐: 재교부증지 700 자동채움(reissueSvcPatch) · 푸터 분해 표시.
// 미리보기(preview)·작업유형(workTypeField)·프리셋 콤보(noteCombo/extraCombo)는 부모가 만들어 node/값으로 넘긴다
// (부모를 import 하면 순환 참조가 된다).
//
// 섹션 구성 = 장부 열 순서 그대로 (2026-09-01 엑셀 정합 — 기타가 재교부 앞):
//   ① 차량   날짜·차량번호·차량명 / 차대번호·구청·비고
//   ② 본 말소 등록세·증지·수수료·세액(자동) + 세금계산서 발행형
//   ③ 기타   기타(비과세)·기타(과세)·부가서비스 + 부가서비스 메모
//   ④ 재교부·원부 재교부증지·재교부수수료·재교부세액(자동)  — legacy 행은 입력 대신 보존 안내

// 라벨/인풋 시각 문법 — 구 모달에서 그대로 옮겨온 단일 원천. CancelAgencySettlement 가 import 해서 쓴다.
export var ls = { display: 'block', fontSize: 11, fontWeight: 600, color: '#64748b', marginBottom: 4, marginTop: 10, fontFamily: 'Pretendard,sans-serif' };
export var is = { width: '100%', padding: '8px 10px', border: '1px solid #d0d5dd', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box', fontFamily: 'Pretendard,sans-serif' };

// 재교부 그룹은 증지 700 이 항상 같이 붙는다(전사 공통 단가, app_meta.cancel_reissue_stamp_duty).
// 수수료를 입력하는 순간 비어 있는 증지 칸을 채워 주되, 사용자가 그 칸을 직접 건드렸으면 존중한다.
var REISSUE_STAMP_DEFAULT = '700';
export var reissueSvcPatch = function (form, v) {
  var patch = { reissueServiceFee: v };
  var cur = String(form.reissueStampDuty || '');
  if ((parseInt(v, 10) || 0) > 0 && !form.rsTouched && (cur === '' || cur === '0')) patch.reissueStampDuty = REISSUE_STAMP_DEFAULT;
  return patch;
};

// 업무 구분 — 말소 외 업무(폐차대행 등)는 같은 장부에 섞여 들어온다. 표시 순서 = 소계 행 순서.
export var JOB_KINDS = ['말소', '폐차대행', '이전등록', '이전대행', '기타'];
export var jobKindOf = function (v) { return JOB_KINDS.indexOf(v) >= 0 ? v : '말소'; };
// 말소가 아닌 행의 비고 앞 배지 (말소는 아무것도 그리지 않아 기존 화면 그대로)
export var JobKindBadge = function (props) {
  var k = jobKindOf(props.kind);
  if (k === '말소') return null;
  return (<span style={{ display: 'inline-block', marginRight: 4, padding: '1px 6px', borderRadius: 8, fontSize: 10, fontWeight: 600, background: '#e0e7ff', color: '#3730a3', whiteSpace: 'nowrap' }}>{k}</span>);
};
// 등록세·증지 자동값 — 수기 추가 기본값(ADD_ITEM_DEFAULT)과 같은 수. 말소 외 업무는 0 으로 시작한다.
var MALSO_AUTO = { registrationTax: '15000', stampDuty: '2300' };

var fmt = function (n) { return (parseInt(n, 10) || 0).toLocaleString(); };
var num = function (n) { return parseInt(n, 10) || 0; };

var secTitle = { fontSize: 11, fontWeight: 600, color: '#94a3b8', letterSpacing: '0.06em', margin: '16px 0 6px' };
var roInput = { background: '#f1f5f9', color: '#475569', textAlign: 'right' };

function SettlementItemDrawer(props) {
  var mode = props.mode, form = props.form || {}, isMobile = !!props.isMobile;
  var onChange = props.onChange, onClose = props.onClose, onSubmit = props.onSubmit;
  var isAdd = mode === 'add';
  var pv = props.preview || { vat: 0, reissueVat: 0, subtotal: 0 };
  var legacy = num(props.legacyReissueSum);
  var firstRef = useRef(null);
  var lockKind = !isAdd && !!form.carId;

  // Esc 닫기 (변경분 확인 없이 그대로 닫는다 — 구 모달의 배경 클릭과 같은 동작) + 열릴 때 첫 입력 포커스
  useEffect(function () {
    var h = function (e) { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    if (firstRef.current) firstRef.current.focus();
    return function () { window.removeEventListener('keydown', h); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var repeat = function (n) { var a = []; for (var i = 0; i < n; i++) a.push('1fr'); return a.join(' '); };
  // 모바일은 어떤 섹션이든 2열 — 3·4열을 좁은 폭에 밀어 넣으면 입력칸이 찌그러진다 (구 모달과 같은 판단)
  var grid = function (n) { return { display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : repeat(n), gap: 10, marginBottom: 10 }; };
  // label + input 세로 스택 — 테스트가 label.parentElement 로 입력을 잡으므로 이 형태를 유지한다
  // grid/flex 자식은 기본 min-width:auto — 셀이 콘텐츠의 min-content 보다 작아지지 못한다.
  // <input type="date"> 는 브라우저 기본 최소폭(모바일 ~150px)이 있어 그대로 두면 2열 셀이
  // 그만큼 벌어져 옆 칸(차량번호)을 밀어낸다 → 겹쳐 보임 (Jin 2026-09-02 모바일 실기).
  var field = function (label, node) { return (<div style={{ minWidth: 0 }}><label style={{ ...ls, marginTop: 0 }}>{label}</label>{node}</div>); };
  var patch = function (k, v) { var p = {}; p[k] = v; onChange(p); };
  var money = function (k) {
    return (<input type="number" inputMode="numeric" style={{ ...is, textAlign: 'right' }} value={form[k] === undefined ? '' : form[k]}
      onChange={function (e) { patch(k, e.target.value); }} />);
  };
  // 자동 계산 칸 — 서버 computeManualItemized 와 같은 식(부모 settlementPreviewOf)의 결과를 그대로 비춘다
  var roMoney = function (v) { return (<input readOnly value={fmt(v)} style={{ ...is, ...roInput }} />); };

  // 푸터 분해 — 소계는 반드시 preview.subtotal 과 같아야 한다(장부/정산서 PDF 와 같은 수).
  // '재교부' 는 다른 칩과 겹치는 횡단 보기(증지=실비 · 수수료=과세분 · 세액=세액에도 들어 있다).
  var costs = num(form.registrationTax) + num(form.stampDuty) + num(form.reissueStampDuty);
  var taxable = num(form.serviceFee) + num(form.otherTaxableFee) + num(form.reissueServiceFee);
  var vats = num(pv.vat) + num(pv.reissueVat);
  var reissue = num(form.reissueStampDuty) + num(form.reissueServiceFee) + num(pv.reissueVat) + legacy;
  var etc = num(form.otherFee) + num(form.extraServiceFee);

  var panel = isMobile
    ? { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: '#fff', display: 'flex', flexDirection: 'column' }
    : { position: 'absolute', top: 0, right: 0, bottom: 0, width: 640, maxWidth: '96vw', background: '#fff', boxShadow: '-16px 0 48px rgba(0,0,0,0.25)', display: 'flex', flexDirection: 'column' };

  return (<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}
    // 배경 클릭 닫기는 수정만 (구 모달과 동일). 수기 추가는 입력 중 오클릭으로 폼이 날아가지 않게 × / 취소 / Esc 로만 닫는다.
    onClick={isAdd ? undefined : onClose}>
    <div role="dialog" aria-modal="true" aria-label={props.title} style={panel}
      onClick={function (e) { e.stopPropagation(); }}
      /* 수기 추가는 Enter 로 바로 저장 — 구 모달 동작 보존(수정 폼에는 없던 동작이라 add 에만 둔다) */
      onKeyDown={isAdd ? function (e) { if (e.key === 'Enter') onSubmit(); } : undefined}>

      {/* 헤더 (고정) */}
      <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, padding: isMobile ? '12px 16px' : '16px 20px', borderBottom: '1px solid #e5e7eb' }}>
        <div>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1B3A5C' }}>{props.title}</h3>
          {!!props.subtitle && <div style={{ marginTop: 3, fontSize: 12, color: '#94a3b8' }}>{props.subtitle}</div>}
        </div>
        <button title="닫기" aria-label="닫기" onClick={onClose} style={isMobile
          ? { background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8', width: 40, height: 40, lineHeight: 1, padding: 0 }
          : { background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#94a3b8', padding: 2, lineHeight: 1 }}>✕</button>
      </div>

      {/* 본문 (스크롤) */}
      <div style={{ flex: '1 1 auto', overflowY: 'auto', padding: isMobile ? '12px 16px 16px' : '14px 20px 20px' }}>
        {props.presenceBanner}
        <div style={secTitle}>차량</div>
        <div style={grid(3)}>
          {field('날짜', <input ref={firstRef} type="date" style={{ ...is, minWidth: 0, WebkitAppearance: 'none' }} value={form.date || ''} onChange={function (e) { patch('date', e.target.value); }} />)}
          {/* 수정 진입 행의 차량번호는 장부 키 — 여기서 고치지 않는다 (구 모달과 같음) */}
          {field('차량번호', <input style={isAdd ? is : { ...is, background: '#f8fafc' }} value={form.carNo || ''} readOnly={!isAdd}
            onChange={function (e) { patch('carNo', e.target.value); }} />)}
          {/* ERP 차량 연결 행은 차량명이 cars JOIN 값 → 읽기전용. walk-in 은 수기 입력. */}
          {field('차량명', <input style={(!isAdd && form.carId) ? { ...is, background: '#f8fafc' } : is} value={form.carType || ''} readOnly={!isAdd && !!form.carId}
            onChange={function (e) { patch('carType', e.target.value); }} />)}
        </div>
        <div style={grid(3)}>
          {isAdd
            ? field('차대번호(끝6)', <input style={{ ...is, fontFamily: 'monospace' }} value={form.vinLast6 || ''} onChange={function (e) { patch('vinLast6', e.target.value); }} />)
            : field('차대번호(뒷8)', <input style={{ ...is, background: '#f8fafc', fontFamily: 'monospace' }} readOnly value={form.vin ? form.vin.slice(-8) : (form.vinLast6 || '')} />)}
          {field('구청', <input list={props.districtListId} style={is} placeholder="예: 강남구청" value={form.district || ''} onChange={function (e) { patch('district', e.target.value); }} />)}
          {field('비고', props.noteCombo)}
          {/* 작업 유형 = 입력 프리셋(단가 3칸 + 비고). 저장되지 않으므로 비고 옆에 둔다 (Jin 2026-09-01). */}
          {props.workTypeField ? field('작업 유형 (프리셋)', props.workTypeField) : null}
        </div>
        {/* 상세 메모 — 장부 비고 칸에 비고 뒤로 이어 붙어 보이는 자유 메모 (엑셀 이관분의 [colN=값] 원본 메모 포함). */}
        <div style={{ marginBottom: 10 }}>
          {field('상세 메모', <textarea style={{ ...is, minHeight: 56, resize: 'vertical', fontFamily: 'inherit' }} placeholder="예: 반납 10/10 · 연수구청"
            value={form.noteDetail || ''} onChange={function (e) { patch('noteDetail', e.target.value); }} />)}
        </div>

        <div style={secTitle}>업무</div>
        <div style={grid(3)}>
          {field('업무', <select style={{ ...is, background: lockKind ? '#f8fafc' : '#fff' }} value={jobKindOf(form.jobKind)} disabled={lockKind}
            onChange={function (e) {
              var k = e.target.value;
              // 추가 모드 한정: 말소→비말소는 기본값 그대로인 칸만 0, 비말소→말소는 0 인 칸만 기본값 복원 (직접 입력값 보존)
              var p = { jobKind: k };
              if (isAdd) {
                var was = jobKindOf(form.jobKind);
                ['registrationTax', 'stampDuty'].forEach(function (f) {
                  var cur = String(form[f] === undefined ? '' : form[f]);
                  if (was === '말소' && k !== '말소' && cur === MALSO_AUTO[f]) p[f] = '0';
                  else if (was !== '말소' && k === '말소' && (cur === '' || cur === '0')) p[f] = MALSO_AUTO[f];
                });
              }
              onChange(p);
            }}>
            {JOB_KINDS.map(function (k) { return <option key={k} value={k}>{k}</option>; })}
          </select>)}
        </div>
        {lockKind && <div style={{ marginBottom: 10, fontSize: 11, color: '#94a3b8' }}>요청에서 생성된 말소 건은 변경할 수 없습니다.</div>}

        <div style={secTitle}>본 말소</div>
        <div style={grid(4)}>
          {field('등록세', money('registrationTax'))}
          {field('증지', money('stampDuty'))}
          {field('수수료', money('serviceFee'))}
          {field('세액', roMoney(pv.vat))}
        </div>
        <label style={{ ...ls, marginTop: 0, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
          {/* B-3 — 사용자가 실제로 건드렸을 때만 issueTouched 를 얹는다(부모가 저장 body 포함 여부를 이걸로 판단) */}
          <input type="checkbox" checked={!!props.issue} onChange={function (e) { onChange({ issueTaxInvoice: e.target.checked, issueTouched: 1 }); }} /> 세금계산서 발행형
        </label>

        <div style={secTitle}>기타</div>
        <div style={grid(3)}>
          {field('기타(비과세)', money('otherFee'))}
          {field('기타(과세)', money('otherTaxableFee'))}
          {/* 요청과 연결된 항목(W8) — 부가서비스 금액은 요청 부가서비스 합계로 서버가 파생(이 칸 전송값은 무시). */}
          {props.linked ? field('부가서비스', roMoney(num(form.extraServiceFee))) : field('부가서비스', money('extraServiceFee'))}
          {props.linked
            ? <div style={{ gridColumn: isMobile ? 'span 2' : 'span 3' }}>
                <label style={{ ...ls, marginTop: 0 }}>부가서비스 (요청 부가서비스에서 자동 계산)</label>
                {props.extraCombo}
              </div>
            : <div style={{ gridColumn: isMobile ? 'span 2' : 'span 3' }}>{field('부가서비스 항목', props.extraCombo)}</div>}
        </div>

        <div style={secTitle}>재교부·원부</div>
        {/* 분해 전(구 재교부·구 원부) 행은 소급 분해하지 않는다 — 입력을 감추고 값만 그대로 보존해 전송한다 */}
        {legacy > 0
          ? <div style={{ marginBottom: 10, padding: '8px 10px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, fontSize: 12, color: '#92400e' }}>
              구 재교부·원부 {fmt(legacy)}원(분해 전) — 그대로 보존됩니다. 재교부 3칸은 새 행부터 씁니다.
            </div>
          : <div style={grid(3)}>
              {field('재교부증지', <input type="number" inputMode="numeric" style={{ ...is, textAlign: 'right' }} value={form.reissueStampDuty === undefined ? '' : form.reissueStampDuty}
                onChange={function (e) { onChange({ reissueStampDuty: e.target.value, rsTouched: 1 }); }} />)}
              {field('재교부수수료', <input type="number" inputMode="numeric" style={{ ...is, textAlign: 'right' }} value={form.reissueServiceFee === undefined ? '' : form.reissueServiceFee}
                onChange={function (e) { onChange(reissueSvcPatch(form, e.target.value)); }} />)}
              {field('재교부세액', roMoney(pv.reissueVat))}
            </div>}

      </div>

      {/* 푸터 (고정) — 분해 칩 + 소계 + 액션 */}
      <div style={{ flex: '0 0 auto', borderTop: '1px solid #e5e7eb', padding: isMobile ? '10px 16px 12px' : '12px 20px 14px', background: '#fff' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, padding: '8px 10px', background: '#f0f4f8', borderRadius: 6, fontSize: 12, color: '#334155' }}>
          <span style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            <span>실비 <b>{fmt(costs)}</b></span>
            <span>과세분 <b>{fmt(taxable)}</b></span>
            <span>세액 <b>{fmt(vats)}</b></span>
            <span>기타 <b>{fmt(etc)}</b></span>
            <span>재교부 <b>{fmt(reissue)}</b></span>
          </span>
          <span>소계 <b style={{ color: '#059669' }}>{fmt(pv.subtotal)}원</b></span>
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          {/* 삭제 진입점은 여기 하나 — 리스트 행에는 삭제 버튼을 두지 않는다 */}
          {!!props.onDelete && <button className="btn btn-outline btn-danger" onClick={props.onDelete}>🗑️ 삭제</button>}
          <button className="btn btn-outline" style={{ flex: 1, justifyContent: 'center' }} onClick={onClose}>취소</button>
          <button className="btn btn-blue" style={{ flex: 1, justifyContent: 'center' }} onClick={onSubmit}>저장</button>
        </div>
      </div>
    </div>
  </div>);
}

export default SettlementItemDrawer;
